<template>
  <div>
    <K-Loading :Loading="Loading" v-if="!datas"></K-Loading>
    <div v-else>

      <!-- 背景音乐 -->
      <K-Music :Music="datas.music"></K-Music>

      <header>化工标签二维码追溯系统</header>

      <section class="box">
        <ul class="MainBox">
          <li>单元识别码：<a v-text="code" v-if="code"></a><a v-else>10191127100806341087444250870653</a></li>
          <li v-if="datas.product.reg_code_str">登记证号：{{datas.product.reg_code_str}}</li>
          <li v-if="datas.product.reg_code_owner">登记证持有人：{{datas.product.reg_code_owner}}</li>
          <li>产品名称：{{datas.product.name}}</li>
          <li v-if="datas.product.alias_name">农药名称：{{datas.product.alias_name}}</li>
          <li>保质期：{{datas.product.period}}</li>
          <li>规格：{{datas.product.unit}}</li>
          <li v-if="datas.attribute && datas.attribute.ship_date">生产日期：{{datas.attribute.ship_date}}</li>
          <li class="MainBoxRow" v-if="datas.product.attribute && (val.key || val.value)" v-for="val in datas.product.attribute">
            <span v-text="val.key+'：'"></span>
            <span v-text="val.value"></span>
          </li>
          <li v-if="datas.batch && datas.batch.name">标签批次：{{datas.batch.name}}</li>
          <li v-if="datas.batch && datas.batch.qc" v-for="val in datas.batch.qc" v-text="val.key+'：'+val.value"></li>
          <li>查询次数：{{datas.scan_count}}</li>
          <li>首次查询时间：{{datas.scan_first_time}}</li>
          <li v-if="datas.scan_first_address">首次查询地点：{{datas.scan_first_address}}</li>
          <li v-else>首次查询地点：正在检测中...</li>
          <li>追溯地址：<a class="skip">https://sy.oid.plus</a></li>
        </ul>
        <!-- <div class="technical">技术支持：温州链接科技有限公司</div> -->
      </section>

    </div>
  </div>
</template>

<script>
let self;
import axios from 'axios'
import Loading from '@/components/Loading.vue'
import Music from '@/components/Music.vue'
export default {
  name: 'Pesticide02',
  components: {
    'K-Loading': Loading,
    'K-Music': Music
  },
  data () {
    return {
      code:null,
      count:2,
      datas:null,
      Loading:{
        type:1,
        txt:"数据请求中..."
      },
      Music:{
        url:null,
        type:false
      }
    }
  },
  created () {
    self = this;

    //判断是演示还是真实码标
    if(this.$route.query.type == "demo"){
      self.GetDemoDatas(this.$route.query.pid,this.$route.query.rid);  //获取演示模板信息
    }else{
      self.code = self.GetCode();
      self.GetDatas();  //获取码标信息
    }

    document.title = "农药二维码追溯系统";  //设置页面标题
    document.body.style.backgroundColor = "#FFF";
  },
  updated () {

  },
  methods:{
    GetDemoDatas (pid,rid) {
      axios.get(self.GetServerUrl(1)+"template_product/"+pid+"/"+rid)
      .then(function (response){
        let datas = response.data.meta;
        let defaultDatas = JSON.parse(datas.default_basic.config_value);  //初始化默认信息

        if(datas.scan_count){
          datas.scan_count = datas.scan_count;
        }else{
          datas.scan_count = 1;
        }
        datas.scan_first_time = "2017-10-31 12:12";
        datas.scan_first_address = "广东省深圳市";
        if(datas.focus){
          datas.focus = JSON.parse(datas.focus);
        }
        if(datas.ref){
          datas.ref = JSON.parse(datas.ref);
        }else{
          if(defaultDatas.ref){
            datas.ref = JSON.parse(defaultDatas.ref);
          }
        }
        if(datas.menu){
          datas.menu = JSON.parse(datas.menu);
        }
        if(datas.batch){
          datas.batch = JSON.parse(datas.batch);
          datas.batch.qc = JSON.parse(datas.batch.qc);
        }
        if(datas.music && datas.music_is_show == 1){
          try {
            datas.music = JSON.parse(datas.music);
          } catch (error) {
            console.error(error)
          }
        }
        if(datas.video){
          datas.video = JSON.parse(datas.video);
        }
        datas.activity_is_show = 1;

        //默认信息
        if(!datas.process){
          datas.process = defaultDatas.process;
        }
        if(!datas.process_demo){
          datas.process_demo = defaultDatas.process_demo;
        }
        if(!datas.dealer){
          datas.dealer = defaultDatas.dealer;
        }
        self.datas = datas;

        // document.title = self.datas.business.name;  //设置页面标题
      }).catch(function (error){
        console.log(error)
        self.Loading.type = 3;
        self.Loading.txt = self.ErrorHint(error);
      })
    },
    GetDatas () {
      axios.get(self.GetServerUrl(1)+"query/"+self.code)
      .then(function (response){
        let datas = response.data.meta.product_template;
        datas.scan_count = response.data.meta.scan_count;  //扫码次数
        datas.scan_first_time = response.data.meta.scan_first_time;  //扫码时间
        datas.scan_first_address = response.data.meta.scan_first_address;  //扫码地点
        //自定义属性
        if(response.data.meta.activation_a){
          datas.attribute = JSON.parse(response.data.meta.activation_a);
        }
        //焦点图
        if(datas.focus){
          datas.focus = JSON.parse(datas.focus);
        }
        //自定义栏目
        if(datas.ref){
          datas.ref = JSON.parse(datas.ref);
        }
        //自定义菜单
        if(datas.menu){
          datas.menu = JSON.parse(datas.menu);
        }
        //产品自定义属性
        if (datas.product.attribute) {
          datas.product.attribute = JSON.parse(datas.product.attribute);
        }
        //批次信息
        if(datas.batch){
          if(datas.batch.qc){
            datas.batch.qc = JSON.parse(datas.batch.qc);
          }
        }
        if(datas.music && datas.music_is_show == 1){
          try {
            datas.music = JSON.parse(datas.music);
          } catch (error) {
            console.error(error)
          }
        }
        if(datas.video){
          datas.video = JSON.parse(datas.video);
        }
        datas.activity_is_show = 1;
        self.datas = datas;

        // document.title = self.datas.business.name;  //设置页面标题
      }).catch(function (error){
        console.log(error)
        self.Loading.type = 3;
        self.Loading.txt = self.ErrorHint(error);
      })
    },
    PreviewImgs () {
      self.$viewer.show();
      self.$viewer.update();
    }
  }
}
</script>

<style scoped>
  header{
    font-size:.6rem;
    color:#FFF;
    padding:.6rem 0;
    text-align: center;
    background-color: #317ef3;
  }
  .MainBox{
    margin:.5rem;
    padding:.5rem;
    background-color: #eaedf1;;
  }
  .MainBox li:first-child{
    margin-top:0;
  }
  .MainBox li{
    color:#333;
    font-size:.58rem;
    margin-top:.5rem;
    word-break: break-all;
  }
  .technical{
    color:#555;
    text-align: center;
    font-size: .52rem;
  }
</style>



// WEBPACK FOOTER //
// src/view/Pesticide02.vue